import { TrashIcon, useBrandDetails } from 'dw-au-react-components';
import styled from '@emotion/styled';
import React from 'react';

const StyledCartItems = styled.div`
	.product_title {
		width: 75%;
	}

	.product_amount {
		width: 25%;
	}
`;

function CartItems({ cartItem, itemCode, removeFromCart, freeItem }) {
	const { tag } = useBrandDetails();
	let {
		skus: [{ salePrice, salePricePerBottle }],
	} = cartItem;
	return (
		<StyledCartItems className='pt-10 pb-20 border-bottom-light-medium'>
			<div className='d-flex justify-content-between mb-6'>
				<div className='product_title'>
					{/* <div className='text_xsmall text-medium text-uppercase mb-4'>
						Item
					</div> */}
					<div className='subtitle roboto lower'>{cartItem.name}</div>
				</div>
				<div className='product_amount'>
					{/* <div className='text_xsmall text-medium text-uppercase mb-4 text-right'>
						Sub total
					</div> */}
					{freeItem ? (
						<div className='text-green text-right font-weight-bold'>
							{tag === 'law' ? 'INCLUDED' : 'FREE'}
						</div>
					) : (
						<div className='subtitle roboto lower text-right'>
							${salePrice.toFixed(2)}
						</div>
					)}
				</div>
			</div>
			{!freeItem && (
				<div className='d-flex justify-content-between align-items-end'>
					<div>
						{/* <div className='mini-cart__item__price text_small text-medium mb-6'>
						<span className='d-inline-block'>1 bottle at</span>{' '}
						<span className='d-inline-block'>
							${salePricePerBottle.toFixed(2)}
						</span>
					</div> */}
						<div
							className='text_small text-medium d-flex align-items-center cursor-pointer'
							onClick={() => removeFromCart(itemCode)}
						>
							<span className='pr-6'>Remove</span>
							<TrashIcon width='8' height='10' />
						</div>
					</div>
					<div className='text-dark-medium'>Qty 1</div>
				</div>
			)}
		</StyledCartItems>
	);
}

export default CartItems;
